export default __webpack_public_path__ + "static/media/ar-dark.3bf48f98.png";